export default "__VITE_ASSET__DZdJCc6P__"